<template>
  <div>
    <div class="panelRow" v-if="writePreview">
      <div>可写模版：</div>
      <a-select
        :disabled="readOnly"
        :filterOption="true"
        :value="model.writeTpls"
        @change="(e) => onChange('writeTpls', e)"
        placeholder="选择模版"
        style="width:90%; font-size:12px"
      >
        <a-select-option
          :key="templateIndex"
          :value="templateValue.id"
          v-for="(templateValue, templateIndex) in templatesBase"
          v-if="templates.indexOf(templateValue.id) !== -1"
        >{{templateValue.name}}</a-select-option>
      </a-select>
    </div>
    <div class="panelRow" v-if="readonlyPreview">
      <div>只读模版：</div>
      <a-select
        :disabled="readOnly"
        :filterOption="true"
        :value="model.readonlyTpls"
        @change="(e) => onChange('readonlyTpls', e)"
        placeholder="选择模版"
        style="width:90%; font-size:12px"
      >
        <a-select-option
          :key="templateIndex"
          :value="templateValue.id"
          v-for="(templateValue, templateIndex) in templatesBase"
          v-if="templates.indexOf(templateValue.id) !== -1"
        >{{templateValue.name}}</a-select-option>
      </a-select>
    </div>
    <div class="panelRow">
      <div>隐藏模版：</div>
      <a-select
        :disabled="readOnly"
        :filterOption="true"
        :value="model.hideTpls"
        @change="(e) => onChange('hideTpls', e)"
        placeholder="选择模版"
        style="width:90%; font-size:12px"
      >
        <a-select-option
          :key="templateIndex"
          :value="templateValue.id"
          v-for="(templateValue, templateIndex) in templatesBase"
          v-if="templates.indexOf(templateValue.id) !== -1"
        >{{templateValue.name}}</a-select-option>
      </a-select>
    </div>
    <div class="panelRow" v-if="ccPreview">
      <div>抄送邮件：</div>
      <a-select
        :filterOption="true"
        :value="model.cc"
        @change="(e) => { onChange('cc', e); getPersons(e) }"
        placeholder="请选择抄送人"
        style="width:90%; font-size:12px"
      >
        <a-select-option :key="user.id" :value="user.id" v-for="user in users">{{user.username}}</a-select-option>
      </a-select>
    </div>
  </div>
</template>
<script>
  export default {
    inject: ['i18n'],
    name: 'NodeDetail',
    props: {
      model: {
        type: Object,
        default: () => { }
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      templates: {
        type: Array,
        default: () => []
      },
      templatesBase: {
        type: Array,
        default: () => []
      },
      writePreview: {
        type: Boolean,
        default: true
      },
      readonlyPreview: {
        type: Boolean,
        default: true
      },
      ccPreview: {
        type: Boolean,
        default: true
      },
      users: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {}
    }
  }
</script>
